<template>
  <Head title="Entrar — CLAUH.DJ" />

  <div class="min-h-screen bg-gradient-to-br from-black via-purple-950 to-black flex items-center justify-center px-4 text-white">

    <!-- Animated background blobs -->
    <div class="fixed inset-0 overflow-hidden pointer-events-none">
      <div class="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-to-br from-fuchsia-600/20 to-transparent rounded-full blur-3xl animate-pulse-slow"></div>
      <div class="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-to-tl from-cyan-600/20 to-transparent rounded-full blur-3xl animate-pulse-slow-delayed"></div>
      <div class="absolute top-1/3 right-1/3 w-96 h-96 bg-purple-600/10 rounded-full blur-3xl animate-float"></div>
    </div>

    <div class="relative w-full max-w-md">

      <!-- Brand -->
      <div class="text-center mb-10">
        <Link href="/" class="inline-block">
          <h1 class="font-black tracking-tighter bg-gradient-to-r from-fuchsia-400 to-cyan-400 bg-clip-text text-transparent" style="font-size: 4rem">
            CLAUH.DJ
          </h1>
        </Link>
        <p class="text-white/40 mt-2 text-xs tracking-[0.3em] uppercase">Admin Panel</p>
      </div>

      <!-- Flash -->
      <div v-if="flash.alert" class="mb-6 p-4 rounded-xl bg-red-500/20 border border-red-500/30 text-red-400 text-sm">
        {{ flash.alert }}
      </div>
      <div v-if="flash.notice" class="mb-6 p-4 rounded-xl bg-green-500/20 border border-green-500/30 text-green-400 text-sm">
        {{ flash.notice }}
      </div>

      <!-- Login card -->
      <div class="p-8 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm">
        <form @submit.prevent="submit" class="space-y-6">

          <div>
            <label class="block text-white/50 text-xs uppercase tracking-widest mb-2">Email</label>
            <input
              v-model="form.email_address"
              type="email"
              required
              autofocus
              autocomplete="username"
              placeholder="seu@email.com"
              class="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 focus:border-fuchsia-500 focus:outline-none focus:ring-2 focus:ring-fuchsia-500/20 transition-all text-white placeholder-white/30 text-sm"
            />
          </div>

          <div>
            <label class="block text-white/50 text-xs uppercase tracking-widest mb-2">Senha</label>
            <input
              v-model="form.password"
              type="password"
              required
              autocomplete="current-password"
              placeholder="••••••••"
              maxlength="72"
              class="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 focus:border-fuchsia-500 focus:outline-none focus:ring-2 focus:ring-fuchsia-500/20 transition-all text-white placeholder-white/30 text-sm"
            />
          </div>

          <div class="pt-2">
            <button
              type="submit"
              :disabled="loading"
              class="w-full py-4 bg-gradient-to-r from-fuchsia-600 to-cyan-600 rounded-xl font-semibold tracking-wide text-base hover:from-fuchsia-500 hover:to-cyan-500 transition-all hover:scale-[1.02] hover:shadow-lg hover:shadow-fuchsia-600/25 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
            >
              {{ loading ? 'Entrando...' : 'Entrar →' }}
            </button>
          </div>

        </form>

        <div class="mt-6 text-center">
          <Link href="/passwords/new" class="text-white/30 hover:text-fuchsia-400 text-sm transition-colors">
            Esqueceu a senha?
          </Link>
        </div>
      </div>

      <div class="text-center mt-8">
        <Link href="/" class="text-white/30 hover:text-white/60 text-xs tracking-wider uppercase transition-colors">
          ← Voltar ao site
        </Link>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Head, Link, router } from '@inertiajs/vue3'

defineProps<{
  flash: { notice?: string; alert?: string }
}>()

const form = ref({ email_address: '', password: '' })
const loading = ref(false)

function submit() {
  loading.value = true
  router.post('/session', form.value, {
    onFinish: () => { loading.value = false }
  })
}
</script>
